
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"#798F8F"}},[_c('path',{staticClass:"i-box",attrs:{"stroke-linecap":"round","d":"M7.5 13.5h-5a1 1 0 0 1-1-1v-10a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6"}}),_c('path',{staticClass:"i-cell5",attrs:{"stroke-linecap":"round","d":"M9.5 7.5h3"}}),_c('path',{staticClass:"i-cell4",attrs:{"stroke-linecap":"round","d":"M9.5 4.5h3"}}),_c('path',{staticClass:"i-cell3",attrs:{"stroke-linecap":"round","d":"M4.5 10.5h3"}}),_c('path',{staticClass:"i-cell2",attrs:{"stroke-linecap":"round","d":"M4.5 7.5h3"}}),_c('path',{staticClass:"i-cell1",attrs:{"stroke-linecap":"round","d":"M4.5 4.5h3"}}),_c('path',{staticClass:"i-stroke",attrs:{"stroke-width":"1.041","d":"M11.818 9.954c.22-.593 1.02-.63 1.312-.111l.052.111.503 1.36 1.36.504c.634.235.634 1.13 0 1.364l-1.36.503-.503 1.36c-.235.634-1.13.634-1.364 0l-.503-1.36-1.36-.503c-.634-.235-.634-1.13 0-1.364l1.36-.503z"}})])])
          )
        }
      }
    